<template>
  <transition name="fade">
    <logo class="logo" />
  </transition>
</template>

<script>
import Logo from '@/assets/images/logos/sellia-logo.svg'

export default {
    components: {
        Logo,
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/views/_login.scss";

.logo {
  width: 250px;
  position: absolute;
  top: 35px;
  right: 50px;
}
</style>
